export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080/api'

// GERAR BUILD PARA API `http://${window.location.host}/api`